import styled from "styled-components";

const LCIconButton = styled.button`
  padding: 0px;
  background: transparent;
  border: none;
  color: ${(props) => (props.type === "secondary" ? "#f3452e" : "#002f53")};
  border-radius: 50%;

  svg {
    font-size: ${(props) => props.size || "26px"};
  }

  &:hover {
    cursor: pointer;
    opacity: 0.6;
  }

  &:focus {
    animation: ${(props) =>
        props.type === "secondary" ? "secondaryPulse" : "primaryPulse"}
      0.4s;
    box-shadow: 0 0 0 10px transparent;
  }

  @keyframes primaryPulse {
    0% {
      box-shadow: 0 0 0 0 #002f53;
    }
  }

  @keyframes secondaryPulse {
    0% {
      box-shadow: 0 0 0 0 #f3452e;
    }
  }
`;
export default LCIconButton;
